import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/accessory',
    meta: { title: '辅料入场验收' },
    component: Layout,
    redirect: '/accessory/list',
    children: [
      {
        path: 'list',
        meta: { title: '辅料入场验收', activeMenu: '/accessory' },
        component: () => import('@/views/accessory/Accessory.vue')
      },
      {
        path: 'detail',
        meta: { title: '辅料入场验收详情', activeMenu: '/accessory' },
        component: () => import('@/views/accessory/AccessoryDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑辅料入场验收', activeMenu: '/accessory' },
        component: () => import('@/views/accessory/AccessoryAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增辅料入场验收', activeMenu: '/accessory' },
        component: () => import('@/views/accessory/AccessoryAdd.vue')
      }

    ]
  }

]
